import Homepage from './Homepage';
import UploadCenter from './UploadCenter';
import FileSearch from './FileSearch';

export default {
    Homepage,
    UploadCenter,
    FileSearch
};